<h1 mat-dialog-title>Frequência Respiratória</h1>
<div mat-dialog-content>
  <div class="modal-body text-center">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()" [appUppercaseForm]="this.setUppercaseText">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12">
          <mat-form-field appearance="outline">
            <mat-label>Frequência Respiratória</mat-label>
            <input [value]="data.discriminatorsValues[this.discriminatorType] ? data.discriminatorsValues[this.discriminatorType].split('/')[0] : null" [mask]="masks.OneAndTwoDigits" type="text" matInput formControlName="respiratoryFrequency">
            <span matSuffix>irpm</span>
          </mat-form-field>
        </div>
      </div>
      @if (data.classificationData && data.classificationData.priorityAutistic && !data.discriminatorsValues[this.discriminatorType]) {
        <div
          class="row">
          <div class="col-12">
            <mat-slide-toggle class="priorityAutistic" (change)="changePriorityAutistic($event)"
              formControlName="priorityAutistic">
              Não é possível aferir
            </mat-slide-toggle>
          </div>
          @if (autisticChecked) {
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>Motivo</mat-label>
                <textarea type="text" matInput formControlName="discriminatorSelectionMotive"></textarea>
              </mat-form-field>
            </div>
          }
        </div>
      }
      <div class="footer-panel-modal-list">
        <div class="row">
          <div class="col-12">
            <button type="submit" mat-flat-button color="primary" class="btn-block">Concluir</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>